import React from "react";
import Table from "../../Common/Table";
import { useHistory } from "react-router-dom";

import TableFields from "../../../constants/Polygon/TableFields.json";
import { getPath } from "../../../utils";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import { Pill } from "../../../constants/assets/containers";

const PolygonList = (props) => {
  const history = useHistory();
  const { polygonList } = props;
  const allActions = MenuActionsMappings[MenuNames.POLYGON];

  const getFieldValue = (polygon, key) => {
    switch (key) {
      case "actions":
        return (
          <Permission
            optionalPerms={[allActions.UPDATE, allActions.DETAIL, allActions.TYPES]}
            notAllowedText="No Allowed Actions"
          >
            <span
              onClick={() => history.push(`/polygons/${polygon.id}`)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      case "is_active":
        return (
          <Pill isFalse={!getPath(polygon, key, undefined)}>
            {getPath(polygon, key, undefined) ? "Yes" : "No"}
          </Pill>
        );
      default:
        return getPath(polygon, key, "");
    }
  };

  return (
    <Table
      list={polygonList}
      getFieldValue={getFieldValue}
      fields={TableFields}
    />
  );
};

export default PolygonList;
